export const GET_ADMIN_SETTINGS = 'GET_ADMIN_SETTINGS';
export const LOADING_ADMIN_SETTING = 'LOADING_ADMIN_SETTING';
export const SAVE_ADMIN_SETTING = 'SAVE_ADMIN_SETTING';
export const LOADING_SAVE_ADMIN_SETTINGS = 'LOADING_SAVE_ADMIN_SETTINGS';
export const EXPORT_DATA_TO_EXCEL = "EXPORT_DATA_TO_EXCEL";
export const EXPORT_LOADER_DATA_EXCEL = "EXPORT_LOADER_DATA_EXCEL";
export const UPDATE_ADMIN_SETTINGS = "UPDATE_ADMIN_SETTINGS";